import React, { useEffect, useState } from "react";
import Pagination from "react-js-pagination";
import NotFound from "../../components/not-found/NotFound";
import ViewListRoundedIcon from "@mui/icons-material/ViewListRounded";
import { Link, useSearchParams } from "react-router-dom";
import IconButton from "../../components/Button/IconButton";
import VisibilityIcon from "@mui/icons-material/Visibility";
import BlockIcon from "@mui/icons-material/Block";
import Switch from "../../components/Switch/Switch";
import { SecondaryButton } from "../../components/Button/Button";
import RotateLeftIcon from "@mui/icons-material/RotateLeft";
import { DatePicker, Select } from "../../components/Form";
import { toast } from "sonner";
import useDebounce from "../../hooks/useDebounce";
// import { getOrderApi } from '../../services/orderManagement'
// import { SiMicrosoftexcel } from "react-icons/si";
import { IoSearch } from "react-icons/io5";
import profileImage from "../../Assests/image/profile_not_found.png";
import { user } from "../../routes/route";
import { getLocalStorage, setLocalStorage } from "../../config/config";
import {
  getUserHistoryApi,
  getUserListApi,
  logoutUserFromAllDevice,
  sendOtpAPi,
  waitlistApi,
  cancelWaitlistApi,
  //   verifyOtpApi,
} from "../../services/userManagement";
import findSerialNumber from "../../utils/findSerialNumber";

import { toastMessage } from '../../utils/toastMessage'
import { fatchCategoryApi } from '../../services/categoryManagement'
import { charLimit } from '../../utils/charLimit'
import common from '../../routes/common'
import UserStatus from "../userManagement/UserStatus";
import { dateFormat, dateFormatUtc } from '../../utils/dateFormat'
import { ConsultationCount, gender } from '../../utils/genderList'
import scrollToUp from '../../utils/scrollToUp'
import { CapitalizeFirstWord } from '../../utils/CapitalizeFirstWord'
import Loader from '../../comman/Loader'
import useDownloadWithPassword from '../../hooks/useDownloadWithPassword'
import csv from '../../Assests/image/csv.svg'
import useButtonLoader from '../../hooks/UseButtonLoader'
import ModalBox from '../../components/modal/ModalBox'
import { useOTPModalCNF } from '../../hooks/useOTPModalCNF'
import { Typography } from "@mui/material";
import ConsultationCustomerTabs from "../../components/PowerCustomer/ConsultationCustomerTabs";
import SectionLoaderOverlay from "../../components/loader/SectionLoaderOverlay";

const { USER_DETAIL, USER_DELETE } = user;
const { NOT_FOUND } = common;


// console.log('Gender', gender)

const WaitlistManagement = () => {
  let URL = process.env.REACT_APP_API_URL
  const [searchParam, setSearchParam] = useSearchParams()
  let activePage = +searchParam.get('page') || 1
  let pageLimit = +searchParam.get('limit') || 10
  const { open: openCNFModal, OTPModalCNF } = useOTPModalCNF();
  const [search, setSearch] = useState(
    getLocalStorage("userList", "search") || ""
  );
  const debounceValue = useDebounce(search || "", 300);
  const [total, setTotal] = useState(0);
  const [userList, setUserList] = useState([]);
  const [problemList, setProblemList] = useState([]);
  const [statusModal, setStatusModal] = useState(false);
  const [statusValue, setStatusValue] = useState("");
  const [statusId, setStatusId] = useState("");
  const [logoutUserModel, setLogoutUserModel] = useState(false);
  const [cancelWaitlistModal, setCancelWaitlistModal] = useState(false);
  const [selectedWaitlistId, setSelectedWaitlistId] = useState("");
  const [isListLoading, setIsListLoading] = useState(false);

  const [buttonref, buttonLoader] = useButtonLoader("Logout");
  const [cancelButtonRef, cancelButtonLoader] = useButtonLoader("Cancel");

  const [WriteOtpModal, setwriteOtpModal] = useState(false);
  const genderValue = searchParam.get("gender") || "";
  const consultationCountValue = searchParam.get("ConsultationCount") || "";
  // const [statusSearch, setStatusSearch] = useState('')
  const registrationDate = searchParam.get("registrationDate") || "";
  const problemValue = searchParam.get("problem") || "";
  const customerType = searchParam.get("customerType") || "normal";
  // const [endDateSearch, setEndDateSearch] = useState('')

  useEffect(() => {
    setLocalStorage("userList", "search", search);
  }, [search]);

  const handleLogoutHandler = async () => {
    try {
      buttonLoader(true);
      const sendData = { userId: statusId };
      const { data } = await logoutUserFromAllDevice(sendData);
      if (data.code === 200) {
        console.log("Date", data);
        logoutCloseModel();
      } else {
        toastMessage(data.message, "error", "userList");
      }
    } catch (error) {
      console.log("error", error);
    } finally {
      buttonLoader(false);
    }
  };

  const handleCancelWaitlist = async () => {
    try {
      cancelButtonLoader(true);
      const sendData = { waitlistId: selectedWaitlistId };
      const { data } = await cancelWaitlistApi(sendData);
      if (data.code === 200) {
        toastMessage(data.message, "success", "userList");
        closeCancelModal();
        getUserList(debounceValue); // Refresh the list
      } else {
        toastMessage(data.message, "error", "userList");
      }
    } catch (error) {
      console.log("error", error);
      toastMessage("Failed to cancel waitlist", "error", "userList");
    } finally {
      cancelButtonLoader(false);
    }
  };

  // handle all hooks
  const { loading, requestDownload, DownloadPasswordModal } = useDownloadWithPassword();


  const handleExcelDownload = () => {
    try {
      const url = `${URL}/admin/user/download`;
      const params = {};
      requestDownload(url, `user-excel-file-${dateFormat(new Date())}`, params);
    } catch (e) {
      console.log(e.message);
    }
  };
  //*********Handel status********* */
  const statusUpdateHandler = (id, status) => {
    setStatusModal(true);
    setStatusId(id);
    setStatusValue(status);
  };

  //*********Logout handler function********* */
  const userLogoutHandler = (id) => {
    setStatusId(id);
    setLogoutUserModel(true);
  };

  // gender handler

  const genderHandler = (value) => {
    if (genderValue === value) {
      searchParam.delete("gender");
    } else {
      searchParam.set("gender", value);
    }
    searchParam.delete("page");
    setSearchParam(searchParam);
  };
  // Problem handler

  const problemValueHandler = (value) => {
    if (problemValue === value) {
      searchParam.delete("problem");
    } else {
      searchParam.set("problem", value);
    }
    searchParam.delete("page");
    setSearchParam(searchParam);
  };
  // consultation count handler

  const TotalconsultationHandler = (value) => {
    if (consultationCountValue === value) {
      searchParam.delete("ConsultationCount");
    } else {
      searchParam.set("ConsultationCount", value);
    }
    searchParam.delete("page");
    setSearchParam(searchParam);
  };

  //*********Handel Pagination********* */
  const handlePageChange = (event) => {
    searchParam.set("page", event);
    setSearchParam(searchParam);
  };

  const handlePageLimitChange = (event) => {
    const newLimit = parseInt(event.target.value);
    searchParam.set("limit", newLimit);
    searchParam.delete("page"); // Reset to first page when changing limit
    setSearchParam(searchParam);
  };
  //*********Handel refresh icon********* */
  const refreshHandler = (event) => {
    setSearch("");
    searchParam.delete("page");
    searchParam.delete("limit");
    searchParam.delete("gender");
    searchParam.delete("problem");
    searchParam.delete("registrationDate");
    searchParam.delete("ConsultationCount");
    setSearchParam(searchParam);
  };
  //------------------usre-listing-Api----------------------------------
  const getUserList = async (debounceValue) => {
    try {
      setIsListLoading(true);
      const sendData = {
        page: `${activePage}`,
        limit: `${pageLimit}`,
        filter: { customerType }
      };

      // if (debounceValue) {
      //   sendData.page = String(activePage)
      //   sendData.search = debounceValue
      //   // searchParam.delete('page')
      //   setSearchParam(searchParam)
      // }
      // if (problemValue) {
      //   sendData.filter.problems = problemValue;
      // }
      // if (genderValue) {
      //   sendData.filter.gender = genderValue;
      // }
      // if (registrationDate) {
      //   sendData.filter.registerDate = registrationDate;
      // }
      // if (consultationCountValue) {
      //   sendData.consultationCountFilter = consultationCountValue;
      // }

      const { data } = await waitlistApi(sendData);
      if (data.code === 200) {
        console.log('data ===>', data.result.list)
        console.log("remainingCoins ===>");
        data.result.list.map((user, index) => {
          console.log(`User ${index + 1}:`, user.remainingCoins);
        });
        setUserList(data?.result?.list || []);
        setTotal(data?.result?.total || 0);
        // scrollToUp();
      } else {
        setUserList([]);
        setTotal(0);
        toastMessage(data.message, "error", "userList");
      }
    } catch (error) {
      console.log("error", error);
    } finally {
      setIsListLoading(false);
    }
  };

  const closeModel = () => {
    setStatusModal(false);
    setStatusValue("");
    setStatusId("");
  };

  const logoutCloseModel = () => {
    setLogoutUserModel(false);
    setStatusId("");
  };

  const openCancelModal = (waitlistId) => {
    setSelectedWaitlistId(waitlistId);
    setCancelWaitlistModal(true);
  };

  const closeCancelModal = () => {
    setCancelWaitlistModal(false);
    setSelectedWaitlistId("");
  };

  // problem list handler function

  const fetchProblemHandler = async () => {
    try {
      const { data } = await fatchCategoryApi();
      if (data.code === 200) {
        setProblemList(data?.result?.categoryList || []);
      } else {
        setProblemList([]);
        toastMessage(data.message, "error", "categoryList");
      }
    } catch (error) {
      console.log("error", error);
    }
  };



  const handleRegistrationDate = (date) => {
    const utcDateString = dateFormatUtc(date);
    searchParam.delete("page");
    searchParam.set("registrationDate", utcDateString);
    setSearchParam(searchParam);
  };

  // useEffect(() => {
  //   if (debounceValue) {
  //     searchParam.set('query', debounceValue)
  //   } else {
  //     searchParam.delete('query')
  //   }
  //   if (activePage === 1) {
  //     searchParam.delete('page')
  //   }
  //   setSearchParam(searchParam)
  //   getOrder(activePage, debounceValue)
  // }, [searchParam, debounceValue])

  useEffect(() => {
    if (Number(activePage) === 1) {
      searchParam.delete("page");
    }
    if (Number(pageLimit) === 10) {
      searchParam.delete("limit");
    }
    if (!genderValue) {
      searchParam.delete("gender");
    }
    if (!problemValue) {
      searchParam.delete("problem");
    }
    setSearchParam(searchParam);
    getUserList(debounceValue);
  }, [searchParam, debounceValue]);

  useEffect(() => {
    fetchProblemHandler();
  }, []);
  return (
    <>
      <OTPModalCNF verifiedHandle={() => {
        console.log('OTP Verified Successfully!')
      }} />
      <div className="WrapperArea">
        <div className="WrapperBox">
          <div className="TitleBox">
            {/* <div className="user_management_heading"> */}
            <h4 className="Title">Waitlist Management</h4>
            <div className="block_user_button">
              {/* <span
                className="user_management_excel"
                onClick={handleExcelDownload}
              >
                {loading ? (
                  <Loader />
                ) : (
                  <div className="csv-image-wrapper">
                    <figure>
                      <img src={csv} alt="csv file download" />
                    </figure>
                  </div>
                )}
              </span> */}
              {/* <div className="mx-2">
                <Link to={`${USER_DELETE}`}>
                  <div className="block_user_button">
                    <button
                    // onClick={() => setAddConsultantModel(true)}
                    >
                      {/* <AddIcon /> */}
              {/* Deleted User
                    </button>
                  </div>
                </Link>
              </div>  */}
            </div>
            {/* </div> */}
          </div>
          <ConsultationCustomerTabs value={customerType} onChange={(value) => {
            searchParam.set("customerType", value);
            searchParam.delete("page");
            setSearchParam(searchParam);
          }} />
          <div className="FilterBox FilterArea">
            {/* <div className="form-group search_lg_size userSearch">
              <input
                type="search"
                className={`form-control ${search && "active"}`}
                placeholder="Search"
                value={search || ""}
                style={{ "--color": "#FF8989" }}
                onChange={(e) => setSearch(e.target.value)}
              />
              <span className="user_search_icon">
                <IoSearch />
              </span>
            </div>   */}
            {/* <div className="form-group select_sm_width">
                <Select
                  className={`form-control ${ConsultationCount && "active"}`}
                  value={consultationCountValue || ""}
                  onChange={(e) => TotalconsultationHandler(e.target.value)}
                >
                  <option value="">Total Consultation</option>
                  {ConsultationCount &&
                    ConsultationCount.length > 0 &&
                    ConsultationCount.map((ConsultationCount, index) => {
                      return (
                        <option value={ConsultationCount.value} key={ConsultationCount.id}>
                          {ConsultationCount.name}
                        </option>
                      );
                    })}
                </Select>
              </div> */}

            {/* <div className="group_filter_value">
              <div className="form-group date_picker">
                <DatePicker
                  className={`form-control ${registrationDate && "active"}`}
                  name="startDate"
                  selected={registrationDate}
                  placeholder="Registration Date"
                  onChange={(date) => handleRegistrationDate(date)}
                  // selectsStart
                  // startDate={startDateSearch}
                  isClearable
                  maxDate={Date.now()}
                />
              </div>

              {/* Gender-Filter */}
            {/* <div className="form-group select_sm_width">
                <Select
                  className={`form-control ${genderValue && "active"}`}
                  value={genderValue || ""}
                  onChange={(e) => genderHandler(e.target.value)}
                >
                  <option value="">Gender</option> */}
            {/* <option value="male">Male</option>
                  <option value="female">Female</option> */}
            {/* {gender &&
                    gender.length > 0 &&
                    gender.map((gender, index) => {
                      return (
                        <option value={gender.value} key={gender.id}>
                          {gender.name}
                        </option>
                      );
                    })}
                </Select> */}
            {/* </div> */}
            {/* Problem filter */}
            {/* <div className="form-group select_sm_width">
                <Select
                  className={`form-control ${problemValue && "active"}`}
                  value={problemValue || ""}
                  onChange={(e) => problemValueHandler(e.target.value)}
                >
                  <option value={""} key={1}>
                    Problem
                  </option>
                  {problemList &&
                    problemList.length > 0 &&
                    problemList.map((problem, index) => {
                      return (
                        <option value={problem._id} key={problem._id}>
                          {charLimit(problem.title, 20)}
                        </option>
                      );
                    })}
                </Select>
              </div> */}
            {/* <div className="form-group refresh_button">
                <SecondaryButton onClick={refreshHandler}>
                  <RotateLeftIcon />
                </SecondaryButton>
              </div>
            </div>  */}
          </div>
          <div className="content-table" style={{ position: "relative", minHeight: 200 }}>
            {isListLoading && <SectionLoaderOverlay />}
            <table>
              <thead>
                <tr>
                  <th>S. No.</th>
                  <th>User Id</th>
                  {/* <th>Profile</th> */}
                  <th>User Name</th>
                  {/* <th>User Id</th> */}
                  <th>User Mobile</th>
                  {/* <th>Status</th> */}
                  <th>User Email</th>
                    <th>Consultant Name</th>
                    <th>Consultant Mobile</th>
                    <th>Consultant Email</th>
                  <th>User Gender</th>

                  <th>Registration Date</th>
                  <th>Date of Birth</th>
                  <th>Mode of Consultation</th>
                  <th>Call Time</th>
                  <th>Status</th>
                  <th>Customer Type</th>
                  <th>Power Origin</th>
                  <th>Power Customer Since</th>
                  <th className="text-center">Action</th>
                </tr>
              </thead>
              <tbody>
                {userList.length > 0 ? (
                  userList.map((user, index) => {
                    console.log("user ===>", user)
                    return (
                      <React.Fragment key={index}>
                        <tr>
                          <td>{findSerialNumber(index, activePage, pageLimit)}</td>
                          <td>{user?.userDetails?.userId}</td>
                          {/* <td className="user_profile_image">
                            <img
                              src={user.profileImage || profileImage}
                              alt={`${user.name} profile image`}
                            />
                          </td> */}
                          <td>{user?.request_form?.firstName || "---"}</td>
                          {/* <td>{user?.referid || "---"}</td> */}
                          <td>
                            {user?.userDetails?.mobile ? (
                              <a href={`tel:${user?.userDetails?.mobile}`} style={{ color: '#FF8989', textDecoration: 'none' }}>
                                {user?.userDetails?.mobile}
                              </a>
                            ) : (
                              "---"
                            )}
                          </td>

                          <td>{user?.userDetails?.email || "---"}</td>
                          <td>{user?.consultantDetails?.accountName}</td>
                            <td>
                              {user?.consultantDetails?.mobile ? (
                                <a href={`tel:${user?.consultantDetails?.mobile}`} style={{ color: '#FF8989', textDecoration: 'none' }}>
                                  {user?.consultantDetails?.mobile}
                                </a>
                              ) : (
                                "---"
                              )}
                            </td>
                              <td>{user?.consultantDetails?.email}</td>
                          <td>
                            {user.request_form?.gender
                              ? CapitalizeFirstWord(user.request_form?.gender)
                              : "---"}
                          </td>
                          <td>{dateFormat(user.createdAt) || "---"}</td>
                          <td>{user.request_form?.dateOfBirth || "---"}</td>
                          <td>{(user?.session_info?.mode) || "---"}</td>
                          <td>
                            {
                              user.logs?.find(log => log.callBy === "user")
                                ? dateFormat(new Date(user.logs.find(log => log.callBy === "user").timestamp))
                                : "---"
                            }
                          </td>
                          <th>{user?.status}</th>
                          <td>{user?.customerType || "---"}</td>
                          <td>{user?.powerOrigin || "---"}</td>
                          <td>{user?.powerCustomerSince ? dateFormat(user.powerCustomerSince) : "---"}</td>
                          <td>
                            <div className="action_button">
                              {user?.status !== "cancelled" && (
                                <button
                                  className="btn btn-danger btn-sm"
                                  onClick={() => openCancelModal(user._id)}
                                >
                                  Cancel
                                </button>
                              )}
                              {user?.status === "cancelled" && (
                                <span className="text-muted">Cancelled</span>
                              )}
                            </div>
                          </td>
                        </tr>
                      </React.Fragment>
                    );
                  })
                ) : (
                  <NotFound
                    cols={18}
                    msg="User not found!"
                    icon={NOT_FOUND}
                    loader={null}
                  />
                )}
              </tbody>
            </table>
          </div>
          <div className="pagination-wrapper mt-4 d-flex justify-content-between align-items-center">
            <div className="d-flex align-items-center gap-3">
              <Typography variant="body2" color="textSecondary">
                Show:
              </Typography>
              <select
                value={pageLimit}
                onChange={(e) => handlePageLimitChange(e)}
                style={{ 
                  padding: '8px 12px', 
                  border: '1px solid #ccc', 
                  borderRadius: '4px',
                  fontSize: '14px',
                  minWidth: '80px'
                }}
              >
                <option value={5}>5</option>
                <option value={10}>10</option>
                <option value={25}>25</option>
                <option value={50}>50</option>
                <option value={100}>100</option>
              </select>
              <Typography variant="body2" color="textSecondary">
                per page
              </Typography>
            </div>
            
            <div className="d-flex align-items-center gap-2">
              <Typography variant="body2" color="textSecondary">
                Showing {((activePage - 1) * pageLimit) + 1} to {Math.min(activePage * pageLimit, total)} of {total} items
              </Typography>
            </div>
            
            {total > pageLimit ? (
              <div className="pagination-wrapper">
                <div className="Pagination">
                  <Pagination
                    activePage={activePage}
                    previousLabel={"previous"}
                    nextLabel={"next"}
                    itemsCountPerPage={pageLimit}
                    totalItemsCount={total}
                    pageRangeDisplayed={5}
                    onChange={handlePageChange}
                    hideDisabled={true}
                  />
                </div>
              </div>
            ) : null}
          </div>
        </div>
      </div>
      {statusModal && (
        <UserStatus
          show={statusModal}
          close={closeModel}
          setListing={setUserList}
          setUserDetail={""}
          status={statusValue}
          id={statusId}
        />
      )}

      {logoutUserModel && (
        <ModalBox
          status={logoutUserModel}
          onClose={logoutCloseModel}
          title="Logout User from all Device"
          description="Do you want to logout the user from all the devices?"
          action={handleLogoutHandler}
          ref={buttonref}
        />
      )}

      {cancelWaitlistModal && (
        <ModalBox
          status={cancelWaitlistModal}
          onClose={closeCancelModal}
          title="Cancel Waitlist"
          description="Are you sure you want to cancel this waitlist entry? This action cannot be undone."
          action={handleCancelWaitlist}
          ref={cancelButtonRef}
        />
      )}

      <DownloadPasswordModal />
    </>
  );
};

export default WaitlistManagement;
